import { useEffect, useState } from 'react';

/** Phone width (< 600 px, the DSM's `bp-sm`): SPEC-003 and SPEC-004 « largeur téléphone ». */
const QUERY = '(max-width: 599.98px)';

export function useNarrow(): boolean {
  const [narrow, setNarrow] = useState(() => typeof window !== 'undefined' && Boolean(window.matchMedia?.(QUERY).matches));
  useEffect(() => {
    const media = window.matchMedia?.(QUERY);
    if (!media) return undefined;
    const update = () => setNarrow(media.matches);
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  return narrow;
}
